import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { Button } from "../components/ui/button";
import { usePageMeta } from "../lib/use-page-meta";

function NotFound() {
  usePageMeta({
    title: "Page not found",
    description: "The page you were looking for does not exist on AimanRe.my.",
    path: window.location.pathname,
  });

  return (
    <div className="container flex min-h-[60vh] flex-col items-center justify-center py-16 text-center">
      <p className="font-serif text-7xl font-semibold text-primary">404</p>
      <h1 className="mt-4 font-serif text-3xl font-semibold tracking-tight">
        This page took a wrong turn
      </h1>
      <p className="mt-3 max-w-md text-muted-foreground">
        The link may be old, or the page may have moved. The home page and the article
        archive are both good places to start again.
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Button asChild>
          <Link to="/">
            Back home <ArrowRight />
          </Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/articles">Browse articles</Link>
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
